"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Spacer = function Spacer(_ref) {
  var size = _ref.size;
  var styles = {
    spacer: {
      fontSize: "".concat(size - 2, "px"),
      height: "".concat(size, "px"),
      lineHeight: "".concat(size, "px")
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.spacer
  }, "\xA0");
};
Spacer.defaultProps = {
  size: 10
};
Spacer.propTypes = {
  size: _propTypes["default"].number
};
var _default = exports["default"] = Spacer;